import React, { Component } from 'react';
import { Modal, Table, Input, InputNumber, DatePicker, Button, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';
import '../css/style.less'

const DateFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
const TextArea = Input.TextArea;

class EditableCell extends Component {
    handleDateChange = (value, dateString) => {
        this.props.onChange(dateString);
    }

    handleInputNumberChange = (value) => {
        this.props.onChange(value);
    }

    handleInputChange = (e) => {
        this.props.onChange(e.target.value);
    }

    getWebType = () => {
        const { type, value, placeholder } = this.props;
        let dom = null;
        if (type == 'INPUTNUMBER') {
            dom = (
                <InputNumber
                    placeholder={`请输入得分(${placeholder})`}
                    precision={0}
                    value={value}
                    style={{ width: '100%' }}
                    onChange={this.handleInputNumberChange}
                />
            );
        } else if (type == 'DATE') {
            const newValue = value ? moment(value) : null;
            dom = (
                <DatePicker
                    value={newValue}
                    placeholder="请选择"
                    onChange={this.handleDateChange}
                />
            );
        } else if (type == 'INPUT') {
            dom = (
                <Input
                    value={value}
                    placeholder="请输入"
                    style={{ width: '100%' }}
                    onChange={this.handleInputChange}
                />
            );
        }
        return dom;
    }

    render() {
        return (
            <div>{this.getWebType()}</div>
        )
    }
}

class UpdateScore extends Component {
    state = {
        visible: false,
        params: {},
        data: [],
    }

    show = (record) => {
        this.setState({
            data: [],
            visible: true,
            params: { ...record },
        }, () => {
            const { src } = this.props;
            if (src == 'member') {
                this.setQuarter();
            }
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    setQuarter = (date) => {
        const dateObj = date ? moment(date) : moment();
        const year = dateObj.year();
        const quarter = dateObj.quarter();
        const startMonth = 1 + 3 * (quarter - 1);
        const endMonth = 3 * quarter;

        const { params } = this.state;
        params.startDate = `${year}-${startMonth < 10 ? `0${startMonth}` : startMonth}`;
        params.endDate = `${year}-${endMonth < 10 ? `0${endMonth}` : endMonth}`;
        this.setState({ params });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { params, params: { userId, endDate, startDate } } = this.state;
        const options = {
            url: API_URL.sumtotal.queryCrcQuarterScoreDetail,
            data: {
                userId,
                startDate,
                endDate,
            },
            dataType: 'json',
            doneResult: res => {
                const {
                    total,
                    fteValue,
                    pmComment,
                    modifyTime,
                    pmEmployeeCode,
                    pmUserCompellation,
                    performancePmCrcScoreId,
                    performancePmCrcScoreDetails: data = [],
                } = res.data;
                data.unshift({
                    name: '当季度平均FTE',
                    relatedValue: `当季度平均FTE：${fteValue || 0}`,
                });
                data.push({
                    index: '总计',
                    scoreValue: total,
                });
                this.setState({
                    data,
                    loading: false,
                    params: {
                        ...params,
                        pmComment,
                        modifyTime,
                        pmEmployeeCode,
                        pmUserCompellation,
                        performancePmCrcScoreId,
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        width: 40,
        render: (text) => text == '总计' ? <strong>总计</strong> : text,
    }, {
        title: '考核内容',
        dataIndex: 'name',
        width: 140,
    }, {
        title: '参考数据',
        dataIndex: 'relatedValue',
        width: 160,
        render: (text, record) => text ? text : record.index == '总计' ? '' : '-',
    }, {
        title: '得分',
        dataIndex: 'scoreValue',
        width: 160,
        render: (text, record) => {
            const { isEdit } = this.props;
            if (isEdit && record.type == 'Other_Contribution_Score') {
                return this.renderColumns(text, record, 'INPUTNUMBER', false, 'scoreValue')
            } else if (record.index == '总计') {
                return <strong>{text}</strong>;
            } else {
                return (text || text === 0) ? text : '-';
            }
        },
    }]

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map((item, index) => {
            return {
                index: index + 1,
                ...item,
            };
        });
        return dataSource;
    }

    renderColumns = (text, record, type, disabled, column) => {
        return (
            <EditableCell
                disabled={disabled}
                value={text}
                type={type}
                placeholder={record.scoreRange}
                onChange={value => this.handleChange(value, record.performancePmCrcScoreDetailId, column)}
            />
        );
    }

    handleChange = (value, key, column) => {
        const newData = [...this.state.data];
        const target = newData.filter(item => item.performancePmCrcScoreDetailId === key)[0];
        if (target) {
            target[column] = value;
            const len = newData.length;
            let result = 0;
            newData.forEach((item, index) => {
                if (index < len - 1) {
                    const { scoreValue = 0 } = item;
                    const parseValue = Number.parseInt(scoreValue, 10);
                    result += Number.isNaN(parseValue) ? 0 : parseValue;
                }
            });
            newData[len -1][column] = result;
            this.setState({ data: newData });
        }
    }

    handleTextAreaChange = (e) => {
        const { params } = this.state;
        this.setState({
            params: {
                ...params,
                pmComment: e.target.value
            }
        });
    }

    onStartChange = (data, dateString) => {
        this.setQuarter(dateString);
    }

    submit = () => {
        const { data, params: { pmComment, performancePmCrcScoreId } } = this.state;
        const newParams = {};
        for (let i = 0, len = data.length; i < len; i++) {
            const { name, type, scoreValue, performancePmCrcScoreDetailId } = data[i];
            if (type === 'Other_Contribution_Score') {
                if (!scoreValue && scoreValue !== 0) {
                    message.warning(`请填写${name}得分！`);
                    return;
                } else {
                    newParams[`map[${performancePmCrcScoreDetailId}]`] = scoreValue;
                }
            }
        }
        if (!pmComment || (pmComment && pmComment.trim() == '')) {
            message.warning('请填写PM总结性评语！');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.sumtotal.setPmScore,
            data: {
                ...newParams,
                pmComment,
                performancePmCrcScoreId
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    visible: false,
                    loading: false,
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options);
    }

    getComment = () => {
        const { isEdit } = this.props;
        const { params: { pmComment, modifyTime, pmEmployeeCode, pmUserCompellation } } = this.state;
        return (
            <div style={{ marginTop: 20, marginBottom: 30 }}>
                {
                    isEdit
                    ?
                        <div>
                            <span style={{ color: 'red' }}>*</span>PM总结性评语：
                            <TextArea
                                rows={4}
                                value={pmComment}
                                placeholder="请输入"
                                onChange={this.handleTextAreaChange}
                                style={{ width: 517, verticalAlign: 'text-top' }}
                            />
                        </div>
                    :
                        <div>
                            <div style={{ position: 'relative', height: 18, marginBottom: 20, paddingLeft: 130 }}>
                                <span style={{ position: 'absolute', top: 0, left: 0 }}>PM总结性评语：</span>
                                <span style={{ whiteSpace: 'initial', wordBreak: 'break-word' }}>{pmComment}</span>
                            </div>
                            {
                                pmComment &&
                                <div>
                                    <p style={{ paddingLeft: 440, lineHeight: '24px' }}>评价人：{pmUserCompellation}({pmEmployeeCode})</p>
                                    <p style={{ paddingLeft: 440, lineHeight: '24px' }}>评价时间：{modifyTime}</p>
                                </div>
                            }
                        </div>
                }
            </div>
        )
    }

    render() {
        const {
            visible,
            params: {
                date,
                endDate,
                startDate,
                employeeCode,
                userCompellation,
            },
            loading,
        } = this.state;
        const { src, isEdit } = this.props;
        return (
            <Modal
                title="CRC季度评分"
                visible={visible}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal crcQuarterScore"
                width="660px"
                maskClosable={false}
                footer={
                    <span>
                        <Button type="ghost" size="large" onClick={this.hide}>关闭</Button>
                        { isEdit && <Button type="primary" size="large" onClick={this.submit} loading={loading}>提交</Button> }
                    </span>
                }
            >
                <Spin spinning={loading}>
                    <div style={{ position: 'relative' }}>
                        {
                            src == 'member'
                            ?
                                <div style={{ lineHeight: '48px' }}>
                                    <span>CRC: {userCompellation}({employeeCode})</span>
                                    <span className="month-range-picker" style={{ marginLeft: 20 }}>
                                        考核时间：
                                        <MonthPicker
                                            className="begin"
                                            format={DateFormat}
                                            value={startDate ? moment(startDate) : null}
                                            allowClear={true}
                                            placeholder="请选择季度"
                                            onChange={this.onStartChange}
                                        />
                                        <MonthPicker
                                            className="end"
                                            format={DateFormat}
                                            value={endDate ? moment(endDate) : null}
                                            allowClear={true}
                                            placeholder="请选择季度"
                                            onChange={this.onStartChange}
                                        />
                                    </span>
                                    <Button style={{ marginLeft: 20 }} type="primary" onClick={this.loadData}>搜索</Button>
                                </div>
                            :
                                <div style={{ lineHeight: '48px' }}>
                                    <span>考核时间：{date}</span>
                                    <span style={{ marginLeft: 32 }}>CRC: {userCompellation}({employeeCode})</span>
                                </div>
                        }
                        <Table
                            scroll={{ x: 570 }}
                            pagination={false}
                            rowKey={row => row.index}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                        />
                        {this.getComment()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateScore;


// WEBPACK FOOTER //
// ./src/components/sumTotal/crcQuarterScore/UpdateScore.js